export const homeFAQs = [
  {
    question: "What is Cervello Eduverse?",
    answer: "Cervello Eduverse is a next-generation education ecosystem in Hyderabad that integrates academic excellence, professional upskilling, and entrepreneurship coaching under one premium roof."
  },
  {
    question: "What programs do you offer?",
    answer: "We offer three primary verticals: Cervello Junior Academy (school & college foundation coaching), Elevare (career-oriented software engineering and data training), and Business Lab (startup advisory & corporate training)."
  },
  {
    question: "Where are you located?",
    answer: "Our main campus is at Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions, Hyderabad, Telangana - 500059."
  },
  {
    question: "Do you offer demo classes?",
    answer: "Yes, we run dedicated 7-day demo sessions for our courses for a nominal fee of ₹99, allowing students to experience our training and syllabus structure before committing."
  }
];

export const elevareFAQs = [
  {
    question: "1. What is Cervello Elevare?",
    answer: "Elevare is a career-focused vertical designed to upskill final-year students, graduates, and switchers, bridging the gap between academic theory and real-world software engineering/data science roles."
  },
  {
    question: "2. Who should join Elevare?",
    answer: "Ideal for college students (3rd year onwards), final-year students, fresh graduates, and career switchers looking to build job-ready portfolios."
  },
  {
    question: "3. What domains are covered?",
    answer: "We offer hands-on coaching in Full-Stack Web Development, Data Analytics, Data Science, Machine Learning, and Career Readiness/Placement prep."
  },
  {
    question: "4. Do you provide internship opportunities?",
    answer: "Yes, the program includes real project experience, industry partner placements, and networking opportunities to build professional portfolios."
  },
  {
    question: "5. Are projects included?",
    answer: "Yes, every course features multiple portfolio-ready capstones, source-controlled repositories, and review cycles."
  },
  {
    question: "6. Is placement guaranteed?",
    answer: "We focus on real skill mastery, mock interviews, and resume building rather than fake guarantees. Outcomes depend on your dedication and effort."
  },
  {
    question: "7. Can I manage this with college or a job?",
    answer: "Yes, sessions are designed with flexible hours, recorded lectures, and special weekend batches."
  },
  {
    question: "8. What certifications do you offer?",
    answer: "Upon completing all capstone reviews and requirements, you will receive industry-recognized completion certificates and project credentials."
  }
];

export const juniorFAQs = [
  {
    question: "1. What is Cervello Junior Academy?",
    answer: "Cervello Junior Academy is a specialized coaching program for Class 10th and Intermediate students, focused on concept mastery and preparation for competitive board & entrance exams."
  },
  {
    question: "2. Who should join Junior Academy?",
    answer: "Designed for Class 10th students, Intermediate (11th/12th) MPC & BiPC streams, and candidates preparing for EAPCET, NEET, and IIT-JEE exams."
  },
  {
    question: "3. What subjects are covered for Class 10th?",
    answer: "We cover Mathematics, General Science (Physics, Chemistry, Biology), and Languages (English, Telugu, Hindi) for comprehensive board prep."
  },
  {
    question: "4. What subjects are covered for Intermediate?",
    answer: "MPC (Maths 1A, 1B, 2A, 2B, Physics, Chemistry) and BiPC (Botany, Zoology, Physics, Chemistry) streams are covered in full details."
  },
  {
    question: "5. Do you provide EAPCET entrance exam preparation?",
    answer: "Yes, we provide dedicated entrance syllabus modules, mock tests, and solving strategies for EAPCET, JEE, and NEET."
  },
  {
    question: "6. What are Foundation Programs?",
    answer: "Foundation programs focus on logic formulation, concept clarity, and mathematical analytics that prepare younger students for future competitive exams."
  },
  {
    question: "7. Can parents track their child's progress?",
    answer: "Yes, we conduct periodic assessments and provide clear metrics, performance reviews, and direct parent-teacher sync cycles."
  },
  {
    question: "8. What makes your coaching different?",
    answer: "We focus on a personalized mentorship structure, low batch sizes to ensure individual attention, and concept-first learning rather than rote memorization."
  }
];

export const businessFAQs = [
  {
    question: "1. What is Cervello Business Lab?",
    answer: "Business Lab is an incubator and acceleration program that helps startup founders, local companies, and entrepreneurs structure, scale, and digitize their business models."
  },
  {
    question: "2. Who should join Business Lab?",
    answer: "Best suited for early-stage startup founders, small business owners seeking scaling models, and corporate professionals aiming to drive digital innovation."
  },
  {
    question: "3. What domains are covered?",
    answer: "We guide founders through Business Planning, Market Feasibility Analysis, Leadership/Operations setup, Venture Capital strategies, and digital platform development."
  },
  {
    question: "4. Do you provide mentorship?",
    answer: "Yes, you receive direct access to startup advisors, corporate experts, and technical architects to optimize operations and marketing channels."
  },
  {
    question: "5. Are projects included?",
    answer: "Yes, we work directly on your business assets—helping you build business plans, pitch decks, software mockups, and legal drafts."
  },
  {
    question: "6. Is funding guaranteed?",
    answer: "We do not guarantee VC investment. We prepare you to be investor-ready, help refine your pitch, and connect you to relevant funding ecosystems."
  },
  {
    question: "7. Can I manage this with my current business?",
    answer: "Yes, our modules are structured as weekly advisory syncs and flexible hybrid consults designed for active founders."
  },
  {
    question: "8. What support is provided after the program?",
    answer: "You join the Cervello alumni network with continuing advisory access, investor demo days, and operational consulting support."
  }
];
